import { Route, Routes, BrowserRouter as Router } from "react-router-dom"
import NotFound from './pages/notfound/index.js';
import Home from './pages/home'
import MyReservations from './pages/my-reservations'
import MapSelect from './pages/map-select'
import VehicleSelect from './pages/vehicle-select'
import TimeSelect from './pages/time-select'
import CarApproval from './pages/car-approval'
import CarReturnApproval from './pages/car-return-approval'
import CarReport from './pages/car-report'
import DelayApproval from './pages/delay-approval'
import Dispatch from './pages/dispatch'
import AdminRedirect from './pages/admin-redirect'
import CarControl from './pages/car-control'
import BindAccount from './pages/bind-account'
import Feedback from './pages/feedback'
import PrivateCarApply from './pages/private-car-apply'
import PrivateCarRecord from './pages/private-car-record'
import PrivateCarReport from './pages/private-car-report'
import { UserProvider } from './contexts/UserContext';
import { NetworkStatusProvider } from './utils/network-status';
import ErrorBoundary from './components/ErrorBoundary';
// 全局统一"返回首页"按钮样式（必须在所有页面 CSS 之后 import）
import './global-back-btn.css';

function App() {
  return (
  <ErrorBoundary>
    <NetworkStatusProvider>
      <UserProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/my-reservations" element={<MyReservations />} />
            <Route path="/map-select/:locationType" element={<MapSelect />} />
            <Route path="/vehicle-select" element={<VehicleSelect />} />
            <Route path="/time-select" element={<TimeSelect />} />
            <Route path="/car-approval" element={<CarApproval />} />
            <Route path="/car-return-approval" element={<CarReturnApproval />} />
            <Route path="/car-report" element={<CarReport />} />
            <Route path="/delay-approval" element={<DelayApproval />} />
            <Route path="/dispatch" element={<Dispatch />} />
            <Route path="/car-control" element={<CarControl />} />
            <Route path="/admin-redirect" element={<AdminRedirect />} />
            <Route path="/bind-account" element={<BindAccount />} />
            <Route path="/settings" element={<BindAccount />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/private-car-apply" element={<PrivateCarApply />} />
            <Route path="/private-car-record" element={<PrivateCarRecord />} />
            <Route path="/private-car-report" element={<PrivateCarReport />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </UserProvider>
    </NetworkStatusProvider>
  </ErrorBoundary>
  );
}

export default App;